import React, { Component } from 'react'
import { connect } from 'react-redux'

import { Button, Form, Container, Row, Col } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import DiscardReason from '../../shared/DiscardReason'
import ValueAddedDistributor from '../../shared/ValueAddedDistributor'
import CompanyInfoReviewDistributor from '../../shared/company-info/distributor/CompanyInfoReviewDistributor'
import { btnSaveText, btnLoadingText } from '../../../shared/constants'
import { finalReviewRoute } from '../../../shared/constants'
import {
  SidebarActiveItem,
  FrontEndError,
  User,
  ShowValueAddedEnum,
  Company,
  NoDataDisplayStateEnum,
  AcceptedUserEnum,
  AppModeEnum,
  distributorTaggingDiscardReasons,
  DistributorDiscardReasonEnum,
} from '../../../shared/models'
import {
  updateSidebarActiveItem,
  setErrors,
  toggleNoDataPage,
} from '../../../store/actions'
import { AppState } from '../../../store'

import {
  validateStringLength,
  getNextFinalReviewTask,
  saveFinalReview,
  cancelActiveRequests,
} from '../../../services'
import TaskPerformersInfo from '../../shared/TaskPerformersInfo'
import {
  getWebSocket,
  sendMessage,
} from '../../../services/base/websocket-service'

interface State {
  xbsWebsite: string
  doneBy: User
  testedBy: User
  holdXbsDescription: string
  testXbsDescription: string
  holdShowValueAddedDescription: string
  testShowValueAddedDescription: string
  discardReason?: DistributorDiscardReasonEnum
  showValueAdded: ShowValueAddedEnum
  showValueAddedDescription: string
  company: Company
  taskId?: number
  description: string
  accepted?: AcceptedUserEnum
  acceptedDiscardExplanation?: AcceptedUserEnum
  showValueAddedDescriptionAccepted?: AcceptedUserEnum
  isSubmitting: boolean
  btnSaveText: string
  discardExplanation: string
  holdDiscardExplanation: string
  testDiscardExplanation: string
}

interface DispatchProps {
  updateSidebarActiveItem: (key: SidebarActiveItem) => void
  toggleNoDataPageDisplayState: (state: NoDataDisplayStateEnum) => void
}

type Props = AppState & DispatchProps

const mapStateToProps = state => ({ ...state })
const mapDispatchToProps = dispatch => ({
  updateSidebarActiveItem: (key: SidebarActiveItem) => {
    dispatch(updateSidebarActiveItem(key))
  },
  toggleNoDataPageDisplayState: (state: NoDataDisplayStateEnum) => {
    dispatch(toggleNoDataPage(finalReviewRoute.eventKey, state))
  },
})

class FinalReviewDistributor extends Component<Props, State> {
  ws: WebSocket | null
  constructor(props: Props) {
    super(props)
    this.ws = null
    this.state = {
      xbsWebsite: '',
      holdXbsDescription: '',
      testXbsDescription: '',
      showValueAdded: ShowValueAddedEnum.No,
      holdShowValueAddedDescription: '',
      testShowValueAddedDescription: '',
      showValueAddedDescription: '',
      description: '',
      doneBy: {} as User,
      testedBy: {} as User,
      isSubmitting: false,
      btnSaveText,
      company: {
        taggingId: '',
        identifier: '',
        identifierSource: '',
        name: '',
        country: '',
        city: '',
        postalCode: '',
        lineOfBusiness: '',
        description: '',
        url: '',
        sic: '',
        classifications: [],
      },
      discardExplanation: '',
      holdDiscardExplanation: '',
      testDiscardExplanation: '',
    }
  }

  async componentDidMount(): Promise<void> {
    await cancelActiveRequests()
    const user = JSON.parse(localStorage.getItem('user') as string)
    this.ws = await getWebSocket(
      `refresh?userId=${user.userId}&section=finalReview&comp_type=distributor`
    )
    if (this.ws) {
      this.ws.onmessage = () => {
        this.reload()
      }
    }
    this.props.updateSidebarActiveItem(finalReviewRoute.eventKey)
    const nextFinalReviewTaskResult = await getNextFinalReviewTask(
      AppModeEnum.Distributors
    )
    const nextTask = nextFinalReviewTaskResult
      ? nextFinalReviewTaskResult.data
      : {}
    if (!nextTask) {
      this.props.toggleNoDataPageDisplayState(NoDataDisplayStateEnum.Show)
    } else {
      this.setState({
        ...nextTask,
        discardReason: nextTask.holdDiscardReason,
        showValueAdded: nextTask.holdShowValueAdded,
      })
    }
  }

  componentWillUnmount(): void {
    this.props.toggleNoDataPageDisplayState(NoDataDisplayStateEnum.Hide)
    if (this.ws) {
      this.ws.close()
    }
  }

  disableButton(): void {
    this.setState({
      isSubmitting: true,
      btnSaveText: btnLoadingText,
    })
  }

  initializeValueAddedDescriptions(data: Record<string, unknown>): void {
    if (!data.holdShowValueAddedDescription) {
      data.holdShowValueAddedDescription = ''
    }
    if (!data.testShowValueAddedDescription) {
      data.testShowValueAddedDescription = ''
    }
  }

  initializeDiscardExplanations(data: Record<string, unknown>): void {
    data.holdDiscardExplanation = data.holdDiscardExplanation || ''
    data.testDiscardExplanation = data.testDiscardExplanation || ''
  }

  async reload(): Promise<void> {
    const nextFinalReviewTaskResult = await getNextFinalReviewTask(
      AppModeEnum.Distributors
    )
    let nextTask = nextFinalReviewTaskResult
      ? nextFinalReviewTaskResult.data
      : null
    if (!nextTask) {
      this.props.toggleNoDataPageDisplayState(NoDataDisplayStateEnum.Show)
    } else {
      this.initializeValueAddedDescriptions(nextTask)
      this.initializeDiscardExplanations(nextTask)
      this.setState({
        ...nextTask,
        discardReason: nextTask.holdDiscardReason,
        showValueAdded: nextTask.holdShowValueAdded,
        showValueAddedDescription: '',
        description: '',
        showValueAddedDescriptionAccepted: undefined,
        accepted: undefined,
        acceptedDiscardExplanation: undefined,
        isSubmitting: false,
        btnSaveText,
        discardExplanation: '',
      })
    }
  }
  async saveAndNext(): Promise<void> {
    if (
      !this.validateDescription() ||
      !this.validateShowValueAddedDescription() ||
      !this.validateDiscardExplanation()
    ) {
      return
    }
    const {
      description,
      discardReason,
      showValueAdded,
      holdShowValueAddedDescription,
      testShowValueAddedDescription,
      showValueAddedDescription,
      company,
      discardExplanation,
    } = this.state
    this.disableButton()
    const result = await saveFinalReview(
      {
        description,
        discardReason,
        discardExplanation,
        showValueAdded,
        holdShowValueAddedDescription,
        testShowValueAddedDescription,
        showValueAddedDescription,
      },
      company.taggingId,
      AppModeEnum.Distributors
    )
    if (result) {
      await this.reload()
      if (this.ws) {
        sendMessage(this.ws, {
          newTask: true,
        })
      }
    }
  }

  setDescription(description: string): void {
    if (Number(this.state.accepted) === AcceptedUserEnum.Initial) {
      this.setState({
        holdXbsDescription: description,
        description,
      })
      return
    }
    this.setState({
      testXbsDescription: description,
      description,
    })
  }

  setDiscardReason(discardReason: DistributorDiscardReasonEnum): void {
    this.setState({
      discardReason,
    })
  }

  setDiscardExplanation(discardExplanation: string): void {
    if (
      Number(this.state.acceptedDiscardExplanation) === AcceptedUserEnum.Initial
    ) {
      this.setState({
        holdDiscardExplanation: discardExplanation,
        discardExplanation,
      })
      return
    }
    this.setState({
      testDiscardExplanation: discardExplanation,
      discardExplanation,
    })
  }

  setShowValueAdded(showValueAdded: ShowValueAddedEnum): void {
    this.setState({
      showValueAdded,
    })
  }

  setHoldShowValueAddedDescription(
    holdShowValueAddedDescription: string
  ): void {
    this.setState({
      holdShowValueAddedDescription,
      showValueAddedDescription:
        Number(this.state.showValueAddedDescriptionAccepted) ===
        AcceptedUserEnum.Initial
          ? holdShowValueAddedDescription
          : this.state.showValueAddedDescription,
    })
  }

  setTestShowValueAddedDescription(
    testShowValueAddedDescription: string
  ): void {
    this.setState({
      testShowValueAddedDescription,
      showValueAddedDescription:
        Number(this.state.showValueAddedDescriptionAccepted) ===
        AcceptedUserEnum.Tester
          ? testShowValueAddedDescription
          : this.state.showValueAddedDescription,
    })
  }

  setAcceptedUser(accepted: AcceptedUserEnum): void {
    this.setState({
      accepted,
      description:
        Number(accepted) === AcceptedUserEnum.Initial
          ? this.state.holdXbsDescription
          : this.state.testXbsDescription,
    })
  }

  setAcceptedDiscardExplanation(
    acceptedDiscardExplanation: AcceptedUserEnum
  ): void {
    this.setState({
      acceptedDiscardExplanation,
      discardExplanation:
        Number(acceptedDiscardExplanation) === AcceptedUserEnum.Initial
          ? this.state.holdDiscardExplanation
          : this.state.testDiscardExplanation,
    })
  }

  setAcceptedShowValueAddedUser(accepted: AcceptedUserEnum): void {
    this.setState({
      showValueAddedDescriptionAccepted: accepted,
      showValueAddedDescription:
        Number(accepted) === AcceptedUserEnum.Initial
          ? this.state.holdShowValueAddedDescription
          : this.state.testShowValueAddedDescription,
    })
  }

  validateDescription(): boolean {
    if (!this.state.accepted) {
      setErrors(
        new FrontEndError('description', 'Description must be selected.')
      )
      return false
    }
    if (!validateStringLength(this.state.description, 1)) {
      setErrors(new FrontEndError('description', 'Description is required.'))
      return false
    }
    return true
  }

  validateShowValueAddedDescription(): boolean {
    if (Number(this.state.showValueAdded) === ShowValueAddedEnum.No) {
      return true
    }
    if (!this.state.showValueAddedDescription) {
      setErrors(
        new FrontEndError(
          'description',
          'Show value added description must be selected.'
        )
      )
      return false
    }
    if (!validateStringLength(this.state.showValueAddedDescription, 1)) {
      setErrors(
        new FrontEndError(
          'description',
          'Show value added description is required.'
        )
      )
      return false
    }
    return true
  }

  validateDiscardExplanation(): boolean {
    if (
      Number(this.state.discardReason) !==
        DistributorDiscardReasonEnum.NotDiscarded &&
      !this.state.acceptedDiscardExplanation
    ) {
      setErrors(
        new FrontEndError(
          'description',
          'Discard Explanation must be selected.'
        )
      )
      return false
    }
    return true
  }

  render(): JSX.Element {
    const {
      noData: { state },
    } = this.props

    if (state === NoDataDisplayStateEnum.Show) {
      return <div />
    }

    if (!this.state.company || !this.state.company.identifier) {
      return <div />
    }

    const {
      company,
      xbsWebsite,
      doneBy,
      testedBy,
      holdXbsDescription,
      testXbsDescription,
      discardReason,
      showValueAdded,
      accepted,
      acceptedDiscardExplanation,
      isSubmitting,
      btnSaveText,
      holdShowValueAddedDescription,
      testShowValueAddedDescription,
      showValueAddedDescriptionAccepted,
      holdDiscardExplanation,
      testDiscardExplanation,
    } = this.state

    return (
      <Form className="form-container">
        <Container fluid className="margin-top-75 padding-bottom-30">
          <CompanyInfoReviewDistributor
            {...{ company, xbsWebsite, testXbsWebsite: xbsWebsite }}
          />
          <hr />
          <Row>
            <Col sm>
              <Form.Group>
                <Row>
                  <Col sm={10}>
                    <Form.Label className="font-weight-bold">
                      Tagger XBS Info
                    </Form.Label>
                  </Col>
                  <Col sm={2}>
                    <Form.Check
                      id={`${AcceptedUserEnum.Initial}-tagger-website`}
                      type="radio"
                      label="Best"
                      value={AcceptedUserEnum.Initial}
                      onChange={({ target }) =>
                        this.setAcceptedUser(Number(target.value))
                      }
                      checked={Number(accepted) === AcceptedUserEnum.Initial}
                    />
                  </Col>
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  disabled={
                    !accepted || Number(accepted) === AcceptedUserEnum.Tester
                  }
                  value={holdXbsDescription}
                  onChange={({ target }) => this.setDescription(target.value)}
                  onBlur={() => this.validateDescription()}
                />
              </Form.Group>
            </Col>
            <Col sm>
              <Form.Group>
                <Row>
                  <Col sm={10}>
                    <Form.Label className="font-weight-bold">
                      Tester XBS Info
                    </Form.Label>
                  </Col>
                  <Col sm={2}>
                    <Form.Check
                      id={`${AcceptedUserEnum.Tester}-tester-website`}
                      type="radio"
                      label="Best"
                      value={AcceptedUserEnum.Tester}
                      onChange={({ target }) =>
                        this.setAcceptedUser(Number(target.value))
                      }
                      checked={Number(accepted) === AcceptedUserEnum.Tester}
                    />
                  </Col>
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  disabled={
                    !accepted || Number(accepted) === AcceptedUserEnum.Initial
                  }
                  value={testXbsDescription}
                  onChange={({ target }) => this.setDescription(target.value)}
                  onBlur={() => this.validateDescription()}
                />
              </Form.Group>
            </Col>
          </Row>
          <hr />
          <Row className="pt-3">
            <Col sm>
              <Row>
                <Col sm>
                  <DiscardReason
                    discardReasons={distributorTaggingDiscardReasons}
                    selected={discardReason}
                    handleChange={reason => this.setDiscardReason(reason)}
                  />
                </Col>
                <Col sm>
                  <ValueAddedDistributor
                    selected={showValueAdded}
                    handleChange={showValueAdded =>
                      this.setShowValueAdded(showValueAdded)
                    }
                    label="Value Added Distributor (VAD)"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col sm>
              <Form.Group>
                <Row>
                  <Col sm={10}>
                    <Form.Label className="font-weight-bold">
                      Tagger Discard Explanation
                    </Form.Label>
                  </Col>
                  <Col sm={2}>
                    <Form.Check
                      id={`${
                        AcceptedUserEnum.Initial
                      }-tagger-discard-explanation`}
                      type="radio"
                      label="Best"
                      value={AcceptedUserEnum.Initial}
                      onChange={({ target: { value } }) => {
                        console.log(value)
                        this.setAcceptedDiscardExplanation(value)
                      }}
                      checked={
                        Number(acceptedDiscardExplanation) ===
                        AcceptedUserEnum.Initial
                      }
                    />
                  </Col>
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  disabled={
                    !acceptedDiscardExplanation ||
                    Number(acceptedDiscardExplanation) ===
                      AcceptedUserEnum.Tester
                  }
                  value={holdDiscardExplanation}
                  onChange={({ target }) =>
                    this.setDiscardExplanation(target.value)
                  }
                  onBlur={() => this.validateDiscardExplanation()}
                />
              </Form.Group>
            </Col>
            <Col sm>
              <Form.Group>
                <Row>
                  <Col sm={10}>
                    <Form.Label className="font-weight-bold">
                      Tester Discard Explanation
                    </Form.Label>
                  </Col>
                  <Col sm={2}>
                    <Form.Check
                      id={`${
                        AcceptedUserEnum.Initial
                      }-tester-discard-explanation`}
                      type="radio"
                      label="Best"
                      value={AcceptedUserEnum.Tester}
                      onChange={({ target: { value } }) =>
                        this.setAcceptedDiscardExplanation(value)
                      }
                      checked={
                        Number(acceptedDiscardExplanation) ===
                        AcceptedUserEnum.Tester
                      }
                    />
                  </Col>
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  disabled={
                    !acceptedDiscardExplanation ||
                    Number(acceptedDiscardExplanation) ===
                      AcceptedUserEnum.Initial
                  }
                  value={testDiscardExplanation}
                  onChange={({ target }) =>
                    this.setDiscardExplanation(target.value)
                  }
                  onBlur={() => this.validateDiscardExplanation()}
                />
              </Form.Group>
            </Col>
          </Row>
          <hr />
          <Row>
            <Col sm>
              <Form.Group>
                <Row>
                  <Col sm={10}>
                    <Form.Label className="font-weight-bold">
                      Tagger Show Value Added
                    </Form.Label>
                  </Col>
                  <Col sm={2}>
                    <Form.Check
                      id={`${AcceptedUserEnum.Initial}-show-value-added`}
                      type="radio"
                      label="Best"
                      value={AcceptedUserEnum.Initial}
                      onChange={({ target }) =>
                        this.setAcceptedShowValueAddedUser(Number(target.value))
                      }
                      checked={
                        Number(showValueAddedDescriptionAccepted) ===
                        AcceptedUserEnum.Initial
                      }
                    />
                  </Col>
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  onChange={({ target }) =>
                    this.setHoldShowValueAddedDescription(target.value)
                  }
                  value={holdShowValueAddedDescription}
                />
              </Form.Group>
            </Col>
            <Col sm>
              <Form.Group>
                <Row>
                  <Col sm={10}>
                    <Form.Label className="font-weight-bold">
                      Tester Show Value Added
                    </Form.Label>
                  </Col>
                  <Col sm={2}>
                    <Form.Check
                      id={`${AcceptedUserEnum.Tester}-tester-value-added`}
                      type="radio"
                      label="Best"
                      value={AcceptedUserEnum.Tester}
                      onChange={({ target }) =>
                        this.setAcceptedShowValueAddedUser(Number(target.value))
                      }
                      checked={
                        Number(showValueAddedDescriptionAccepted) ===
                        AcceptedUserEnum.Tester
                      }
                    />
                  </Col>
                </Row>
                <Form.Control
                  as="textarea"
                  rows={4}
                  onChange={({ target }) =>
                    this.setTestShowValueAddedDescription(target.value)
                  }
                  value={testShowValueAddedDescription}
                />
              </Form.Group>
            </Col>
          </Row>
          <hr />
          <TaskPerformersInfo {...{ doneBy, testedBy }} />
          <hr />
          <Row className="form-container-actions pr-3 justify-content-end">
            <Button
              className="btn btn-purple"
              onClick={() => this.saveAndNext()}
              disabled={isSubmitting}
            >
              <FontAwesomeIcon icon={faArrowRight} /> {btnSaveText}
            </Button>
          </Row>
        </Container>
      </Form>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FinalReviewDistributor)
